import { useCallback, useEffect, useState } from "react";

const KEY = "mizubini_stars_v1";
export const CELEBRATED_KEY = "mizubini_sky_celebrated_v1";
const EVENT = "mizubini-stars";

// Every hidden star of the site; positions are used in Bini's sky
export const STARS = [
  { id: "home-cloud", x: 18, y: 22, color: "#FFD21F" },
  { id: "home-menu", x: 74, y: 16, color: "#FF8A1F" },
  { id: "songs-title", x: 46, y: 34, color: "#FF5FA8" },
  { id: "songs-bottom", x: 84, y: 44, color: "#4CC417" },
  { id: "song-page", x: 28, y: 52, color: "#38B6FF" },
  { id: "coloring", x: 62, y: 60, color: "#8A3FE0" },
];

const read = () => {
  try {
    const ids = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(ids) ? ids.filter((id) => STARS.some((s) => s.id === id)) : [];
  } catch {
    return [];
  }
};

export const useStars = () => {
  const [found, setFound] = useState(read);

  useEffect(() => {
    const sync = () => setFound(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);

  const collect = useCallback((id) => {
    const ids = read();
    if (ids.includes(id)) return;
    localStorage.setItem(KEY, JSON.stringify([...ids, id]));
    window.dispatchEvent(new Event(EVENT));
  }, []);

  const reset = useCallback(() => {
    localStorage.removeItem(KEY);
    localStorage.removeItem(CELEBRATED_KEY);
    window.dispatchEvent(new Event(EVENT));
  }, []);

  return { found, collect, reset, total: STARS.length };
};
